import React from "react";
import { STAGE_COLORS } from "@/lib/adminApi";

export default function StatusPill({ status }) {
    const cls = STAGE_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <span
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${cls}`}
            data-testid={`status-pill-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
        >
            {status || "—"}
        </span>
    );
}
